import Layout from "../components/layout/Layout";
import OneTimeMessagePage from "../components/page/OneTimeMessagePage";


const OneTimeMessagePages = () => {

    return (
        <Layout>
            <OneTimeMessagePage />
        </Layout>
    )
}

export default OneTimeMessagePages;